"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const native_1 = require("@react-navigation/native");
const react_i18next_1 = require("react-i18next");
const NavigationWrapperWeb_1 = __importDefault(require("./NavigationWrapperWeb"));
const images_1 = require("../../services/images");
const ButtonWeb_1 = __importDefault(require("./ButtonWeb"));
const FinishScreenWeb = ({ children, type = "Success", title, subtitle, showMyFlightsBtn = false }) => {
    const navigation = (0, native_1.useNavigation)();
    const [t] = (0, react_i18next_1.useTranslation)("i18n");
    return ((0, jsx_runtime_1.jsx)(NavigationWrapperWeb_1.default, { children: (0, jsx_runtime_1.jsxs)("div", { className: "success-screen", children: [type === "Success" ?
                    (0, jsx_runtime_1.jsx)("img", { src: images_1.icons.Success, alt: "Success" })
                    :
                        (0, jsx_runtime_1.jsx)("img", { src: images_1.icons.Canceled, alt: "Canceled" }), (0, jsx_runtime_1.jsxs)("div", { className: "success-message", children: [(0, jsx_runtime_1.jsx)("p", { className: "title", children: title }), (0, jsx_runtime_1.jsx)("p", { className: "subtitle", children: subtitle })] }), showMyFlightsBtn &&
                    (0, jsx_runtime_1.jsx)("div", { className: "success-buttons", children: (0, jsx_runtime_1.jsx)(ButtonWeb_1.default, { type: "Blue", onClick: () => navigation.navigate("MyFlights"), fullWidth: true, children: t('success_info_page.my_flights') }) }), children] }) }));
};
exports.default = FinishScreenWeb;
